module.exports = __webpack_public_path__ + "static/media/finPicTwo.fc54506a.jpg";